import GeographicLocationPicker from '@/components/forms/GeographicLocationPicker';
import { AdCampaignLocationTarget } from '@/types/ads';
import { useTranslation } from '@/hooks/useTranslation';

type LocationTargetSelectorProps = {
  value: AdCampaignLocationTarget[];
  onChange: (next: AdCampaignLocationTarget[]) => void;
  disabled?: boolean;
  title?: string;
  help?: string;
};

export default function LocationTargetSelector({ value, onChange, disabled, title, help }: LocationTargetSelectorProps) {
  const { t: { audience: copy } } = useTranslation();
  return <GeographicLocationPicker disabled={disabled} label={title ?? copy.geography} help={help ?? copy.includeHelp}
    value={value.map(target => ({ countryId: target.countryId, adminAreaId: target.adminAreaId ?? '', localityId: target.localityId ?? '' }))}
    onChange={targets => onChange(targets.map(target => ({
      countryId: target.countryId, adminAreaId: target.adminAreaId || undefined, localityId: target.localityId || undefined,
    })))} />;
}
